import React, { useState, useEffect } from 'react';
import { Box, Stack, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import moment from 'moment';

import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import FilterBy from '../../../components/common/FilterBy';
import { SearchBar } from '../../../components/common/SearchBar';
import {
  CustomPagination,
  PersitedDatePicker,
  TableCustom,
  TextAreaInput,
} from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';
import {
  EditIconButton,
  DeleteIconButton,
  ViewIconButton,
} from '../../../components/common/button/CustomIconButton';
import Create from './Create';
import ModalCustom from '../../../components/common/Modal';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { IData } from './helpers/interfaces';
import ViewFile from './components/ViewFile';
import formatDate from '../../../components/common/formatDate';
import TableScroll from '../../../components/ui/renderTable/TableScroll';

const getYearRange = (currentDate: any) => {
  if (!currentDate) return;
  const year = new Date(currentDate).getFullYear();
  return `${year} - ${year + 1}`;
};
const tableHeaderObj = [
  [
    {
      text: 'PLAN',
      rowspan: 1,
      colspan: 8,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'DO',
      rowspan: 1,
      colspan: 4,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'CHECK',
      rowspan: 1,
      colspan: 11,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'HORIZONTAL DEPLOYMENT',
      rowspan: 3,
      colspan: 1,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'LESSONS LEARNT',
      rowspan: 3,
      colspan: 1,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'ACT',
      rowspan: 1,
      colspan: 7,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'Status (Open / Close)',
      rowspan: 3,
      colspan: 1,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'REMARKS',
      rowspan: 3,
      colspan: 1,
      style: { background: '#38d9a9', border: '1px solid black' },
    },
    {
      text: 'DEFECT PHOTO',
      rowspan: 3,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'SUPPORTING DOCUMENTS',
      rowspan: 3,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'ACTION',
      rowspan: 3,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
  ],

  [
    {
      text: 'SR. NO.',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'DATE OF OCCURRENCE',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '150px',
        border: '1px solid black',
      },
    },
    // {
    //   text: 'FINANCIAL YEAR',
    //   rowspan: 2,
    //   colspan: 1,
    //   style: { background: '#38d9a9', minWidth: '100px' },
    // },
    {
      text: 'PART NAME',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'PART NO.',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'CUSTOMER',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '150px',
        border: '1px solid black',
      },
    },
    {
      text: "DEFECT QTY.(In No's)",
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'DEFECT DETAIL',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '250px',
        border: '1px solid black',
      },
    },
    {
      text: 'ROOT CAUSE',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '250px',
        border: '1px solid black',
      },
    },
    {
      text: 'ACTION TO BE TAKEN',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '250px',
        border: '1px solid black',
      },
    },
    {
      text: 'TARGET DATE',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'ACTUAL CLOSURE DATE',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'RESPONSIBILITY',
      rowspan: 2,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'EFFECTIVENESS',
      rowspan: 1,
      colspan: 11,
      style: {
        background: '#38d9a9',
        border: '1px solid black',
      },
    },
    {
      text: 'INSTITUTIONALISE THE PROBLEM WITH UPDATION OF FOLLOWINGS',
      rowspan: 1,
      colspan: 7,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
  ],
  [
    {
      text: '',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    ...Array.from({ length: 10 }, (_, index) => ({
      text: `L${index + 1}`,
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    })),

    {
      text: 'QUALITY ALERT',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'DRG. / PFD',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'PFMEA',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'CONTROL PLAN',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'INSPECTION STD.',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'WORK INSTRUCTIONS',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
    {
      text: 'TRAINING',
      rowspan: 1,
      colspan: 1,
      style: {
        background: '#38d9a9',
        minWidth: '100px',
        border: '1px solid black',
      },
    },
  ],
];

//const filterOptions = [{ value: 'customer_name', name: 'Customer Name' }];
//const newFilterOptions = [{ value: 'defect_name', name: 'Defect Reported' }];

const List = () => {
  const [data, setData] = useState<IData[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [complaintId, setComplaintId] = useState<string | null>(null);
  const [perPage, setPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState(0);
  const [id, setId] = useState<string | null>(null);
  const [isFileOpenPopup, setIsFileOpenPopup] = useState(false);
  const [contentType, setContentType] = useState('');
  const [filterCustomer, setFilterCustomer] = useState<any>([]);
  const [filterDefectsReported, setFilterDefectsReported] = useState<any>([]);
  const search = useQuery('search') || '';
  const filter = useQuery('filter') || 'createdAt';
  const page = useQuery('page') || 1;
  const customer = useQuery('customer');
  const defect = useQuery('defects');
  const [all, setAll] = useState(false);
  const date = useQuery('date');

  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this?',
  );

  useEffect(() => {
    axios
      .get('/api/customerRoutes/customerList/customerForAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((customer: any) => ({
            name: customer.customer_name,
            value: customer.customer_name,
          }));
          setFilterCustomer([...formattedData]);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get('/api/defectRoutes/defectList/defectForAutoComplete')
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((defect: any) => ({
            name: defect.defect_name,
            value: defect.defect_name,
          }));
          setFilterDefectsReported([...formattedData]);
        }
      })
      .catch((err) => console.log(err));
  }, []);
  const fetchData = async () => {
    if (date) {
      const res = await axios
        .get(
          `/api/customerConcernRoutes/allYearBy/${date}/?page=${page}&sortBy=${filter}&search=${search}&perPage=${perPage}&customer=${customer}&defects=${defect}&all=${all}`,
        )
        .catch((err) => {
          console.log(err);
        });

      setData(res?.data?.results);
      setPerPage(res?.data?.perPage);
      setTotalPages(res?.data?.pages);
    }
  };

  const deleteCustomerConcern = async (id: string) => {
    const ans = await confirmDelete();
    if (!ans) return;
    await axios
      .delete(`/api/customerConcernRoutes/${id}`)
      .then((res) => {
        alert('Document deleted successfully');
        setRender((prev) => !prev);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchData, 500, [
    page,
    search,
    render,
    isModal,
    filter,
    customer,
    defect,
    all,
    date,
  ]);
  // console.log('hjghghj', date);
  return (
    <>
      <ChildHeader text="CUSTOMER CONCERN REGISTER">
        <AddButton
          onClick={() => {
            setAll((value) => !value);
          }}
          label={all ? 'Hide' : 'Save'}
        />
        <AddButton
          onClick={() => setIsModal(true)}
          label="NEW CUSTOMER CONCERN"
        />
      </ChildHeader>
      <SearchFilterContainer filter={true}>
        {/*<SearchBar label="Search By Customer Name" />*/}
        <Box style={{ display: 'flex', margin: 2 }}>
          <PersitedDatePicker
            label={`Search by Year`}
            views={['year']}
            sx={{ minWidth: 300 }}
          />

          <FilterBy
            sx={{ minWidth: 500, marginLeft: 15 }}
            name="customer"
            label="Filter By Customer"
            options={filterCustomer}
          />
          <FilterBy
            sx={{ minWidth: 300, marginLeft: 2 }}
            name="defects"
            label="Filter By Defects Reprted"
            options={filterDefectsReported}
          />
        </Box>
      </SearchFilterContainer>

      <TableScroll>
        <TableCustom tableHeaderObj={tableHeaderObj}>
          <TableBody>
            {data &&
              data.map((item: IData, index: number) => (
                <React.Fragment key={item._id}>
                  <TableRow>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {perPage * (+page - 1) + index + 1}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.issue_reported_date &&
                        formatDate(item.issue_reported_date)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.part_id?.part_name}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.part_id?.part_number}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.customer_id?.customer_name}
                    </TableCell>
                    {/* <TableCell align="center">
                      {item.issue_reported_date &&
                        getYearRange(item.issue_reported_date)}
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.defect_qty}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      <TextAreaInput
                        value={item.defect_id?.defect_name}
                        style={{ minWidth: '250px', minHeight: '50px' }}
                      />
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      <TextAreaInput
                        value={item?.root_cause}
                        style={{ minWidth: '250px', minHeight: '50px' }}
                      />
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      <TextAreaInput
                        value={item.action_taken}
                        style={{ minWidth: '250px', minHeight: '50px' }}
                      />
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.target_date && formatDate(item.target_date)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.actual_closure_date &&
                        formatDate(item.actual_closure_date)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.responsibility}
                    </TableCell>
                    <TableCell
                      sx={{ minWidth: '150px', border: '1px solid black' }}
                    >
                      Inv. Date
                      <br /> <hr />
                      Inv. No.
                      <br /> <hr />
                      Dispatch Qty.
                      <br /> <hr />
                      Status (OK/NG)
                    </TableCell>

                    {Array.from({ length: 10 }, (_, i) => (
                      <TableCell
                        align="center"
                        sx={{ minWidth: '150px', border: '1px solid black' }}
                      >
                        {item?.[`l${i + 1}_invoice_date`] &&
                          formatDate(item?.[`l${i + 1}_invoice_date`])}
                        <br /> <hr />
                        {item?.[`l${i + 1}_invoice_no`]}
                        <br /> <hr />
                        {item?.[`l${i + 1}_dispatch_qty`]}
                        <br /> <hr />
                        {item?.[`l${i + 1}_status`]}
                      </TableCell>
                    ))}
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.horizontal_delotment}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.lessons_learnt}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.quality_alert}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.pfd}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.pfmea}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.control_plan}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.inspection_std}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.work_instruction}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.training}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.status}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {item.remarks}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {
                        <ViewIconButton
                          tooltipTitle="view"
                          onClick={() => {
                            setId(item._id || null);
                            setIsFileOpenPopup(true);
                            setContentType('image');
                          }}
                        />
                      }
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ border: '1px solid black' }}
                    >
                      {
                        <ViewIconButton
                          tooltipTitle="view"
                          onClick={() => {
                            setId(item._id || null);
                            setIsFileOpenPopup(true);
                            setContentType('file');
                          }}
                        />
                      }
                    </TableCell>
                    <TableCell sx={{ border: '1px solid black' }}>
                      <Stack direction="row" sx={{ justifyContent: 'center' }}>
                        <EditIconButton
                          tooltipTitle="EDIT"
                          onClick={() => {
                            setComplaintId(item?._id || '');
                            setIsModal(true);
                          }}
                        />

                        <DeleteIconButton
                          tooltipTitle="DELETE"
                          onClick={() => {
                            deleteCustomerConcern(item?._id || '');
                          }}
                        />
                      </Stack>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
          </TableBody>
        </TableCustom>
      </TableScroll>
      <CustomPagination totalPage={totalPages} />
      <ModalCustom
        openModal={isModal}
        closeModal={() => {
          setComplaintId(null);
          setIsModal(false);
        }}
        title="CUSTOMER CONCERN REGISTER"
      >
        <Create id={complaintId} setIsModal={setIsModal} />
      </ModalCustom>
      <ModalCustom
        title="FILE LIST"
        openModal={isFileOpenPopup}
        closeModal={() => {
          setId(null);
          setIsFileOpenPopup(false);
        }}
      >
        <ViewFile id={id} contentType={contentType} />
      </ModalCustom>
      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
